import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import AppContainer from "../Appcontainer";
import store from "../../store";
import { Provider } from "react-redux";
import Login from "../../views/pages/LoginPage/Login";
import Payment from "../../views/pages/Payment/Payment";
import Kyc from "../../views/pages/Kyc/Kyc";
import Otp from "../../views/pages/Otp/Otp";
import ForgotPassword from "../../views/pages/forgotPassword/forgotPassword";
import ChangePassword from "../../views/pages/ChanagePasword/changePassword";
import Docuseal from "../../views/pages/Docuseal/docuseal";
import NotFound from "../../views/pages/ErrorMessage/error";
import SubmitSuccess from "../../views/pages/SuccessMessage/successMessage";
import {
  getAccessToken,
  clearTokens,
} from "../../lib/utils/tokenUtils";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

/**
 * Blocks every protected app URL ( /usersList, /dashboard, … )
 * unless an access token exists. Soft Navigate is not enough on full page loads.
 */
const RequireAuth = ({ children }) => {
  const token = getAccessToken();

  useEffect(() => {
    if (!token) {
      clearTokens();
      // Hard redirect so pasted URLs cannot stay on protected pages
      if (window.location.pathname !== "/") {
        window.location.replace("/");
      }
    }
  }, [token]);

  if (!token) {
    return null;
  }

  return children;
};

const AppRouter = () => {
  return (
    <div>
      <Provider store={store}>
        <BrowserRouter basename="/">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/Payment/:slug" element={<Payment />} />
            <Route path="/kyc/:slug" element={<Kyc />} />
            <Route path="/otp" element={<Otp />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/Sign/:id" element={<Docuseal />} />
            <Route
              path="/not-found"
              element={<NotFound message="Page not found." />}
            />
            <Route path="/submit-success" element={<SubmitSuccess />} />
            <Route
              path="/*"
              element={
                <RequireAuth>
                  <AppContainer />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
};

export default AppRouter;
